import { render, staticRenderFns } from "./HeaderQuestions.vue?vue&type=template&id=7510ccfa&"
import script from "./HeaderQuestions.vue?vue&type=script&lang=js&"
export * from "./HeaderQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports